var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgInbox = function SvgInbox(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19,
    fill: "none",
    viewBox: "0 0 24 19",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0.6 0 0 0 0 0 0.6 0 0 0 0 0 0.6 0 0 0 0 0 1 0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.37 1.084A3.02 3.02 0 0 1 6.686 0h7.835c.828 0 1.619.34 2.187.938l4.294 4.523c.529.557.824 1.295.824 2.062v4.164a4.3 4.3 0 0 0-1.255-.187 4.257 4.257 0 0 0-4.086 5.47l-13.492-.077a3.005 3.005 0 0 1-2.993-3V7.412c0-.7.246-1.378.694-1.917zM2.99 6.748l3.23-3.886c.191-.23.475-.362.773-.362h7.597c.293 0 .57.128.762.35l3.352 3.897a.455.455 0 0 1-.347.753h-4.811a2.755 2.755 0 0 1-2.76 2.75 2.755 2.755 0 0 1-2.76-2.75H3.347a.46.46 0 0 1-.355-.752",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.192 4a.5.5 0 0 1 .5-.5h6.777a.5.5 0 0 1 0 1H7.692a.5.5 0 0 1-.5-.5M24 15.875A3.13 3.13 0 0 1 20.864 19a3.13 3.13 0 0 1-3.136-3.125 3.13 3.13 0 0 1 3.136-3.125A3.13 3.13 0 0 1 24 15.875M6.438 5.25a.5.5 0 0 0 0 1h9.285a.5.5 0 0 0 0-1z",
    clipRule: "evenodd",
    filter: "url(#a)"
  })));
};
export default SvgInbox;